import React from 'react';

import { getClickAttrs } from '../../Analytics/gtag';
import { clickCategories } from '../../../utils/analytics';
import { navigationIDs } from '../../Analytics/testIDConfig';
import Img from '../../Img';

import styles from '../header.scss';

const MobileToggleMenu = ({ onClick }) => {
    return (
        <div
            className={styles.navIconLink}
            onClick={onClick}
            data-testid="header.mobile-toggle-menu"
            {...getClickAttrs({
                category: clickCategories.HEADER,
                context: `Toggle Menu`,
                location: 'Top header navigation',
                testid: `${navigationIDs.toggleMenu.component}-${navigationIDs.toggleMenu.location}-${navigationIDs.toggleMenu.id}`,
            })}
        >
            <span className="sr-only">Toggle Menu</span>
            <Img className="hamburger" src={'/img/icons/hamburger.svg'} />
            <div className={`title`}>
                Menu
            </div>
        </div>
    );
};

export default MobileToggleMenu;
